import {Transaction} from "../domain/Transaction";

export const handleTransactionDelete = (
  deletedTransactionId: string,
  transactions: Transaction[]
): Transaction[] => {
  return transactions.filter((transaction) => transaction.id !== deletedTransactionId)
}